export const SUPPORT_CHAT_OPEN_EVENT = 'vemmac:support-chat-open';

export const SUPPORT_CHAT_STORAGE_KEY = 'vemmac_support_chat';

export const SUPPORT_CHAT_CATEGORIES = [
  { key: 'quick_order', label: 'Quick Order' },
  { key: 'catering_enquiry', label: 'Catering Enquiry' },
  { key: 'rental_enquiry', label: 'Rental Enquiry' },
  { key: 'existing_order', label: 'Existing Order' },
  { key: 'payment_issue', label: 'Payment Issue' },
  { key: 'report_problem', label: 'Report a Problem' },
  { key: 'general_enquiry', label: 'General Enquiry' },
];

export function getSupportCategoryLabel(category) {
  return SUPPORT_CHAT_CATEGORIES.find((item) => item.key === category)?.label || 'General Enquiry';
}

export function openSupportChat(detail = {}) {
  window.dispatchEvent(new CustomEvent(SUPPORT_CHAT_OPEN_EVENT, { detail }));
}

